import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {Input} from "reactstrap";
import Checkbox from "../../../shared/forms/Checkbox";
import './Question.scss'
import DisplayQuestionImage from './DisplayQuestionImage';
import classNames from 'classnames'

class Question extends Component {

  constructor(props) {
    super(props);

    this.state = {
      score: 0
    }
  }

  updateAnswer(e, answer) {
    let answers = this.props.answers || [];
    if (e.target.checked) {
      answers = [answer.id] // [...answers, answer.id]
    } else {
      answers = [] //answers.filter(a => a !== answer.id)
    }

    this.props.onAnswer({answers, correct: this.checkIfCorrect(answers)});
  }

  get isCorrect() {
    if (!this.props.answers) {
      return false
    }
    if (this.props.question.isSubjective) {
      return this.subjectiveGrades.every(grade => grade === true);
    }
    return this.checkIfCorrect(this.props.answers.answers);
  }

  get isGraded() {
    if (this.props.question.isSubjective && this.props.answers) {
      return this.subjectiveGrades.length === this.answerLines && this.subjectiveGrades.every(grade => grade === false || grade === true);
    }
    return true;
  }

  updateMultipleAnswer(e, answer) {
    let answers = this.props.answers || [];
    if (e.target.checked) {
      if (answers && answers.answers) {
        let modifiedAnswers = [
          ...answers.answers,
          answer.id
        ];

        answers = modifiedAnswers;
      }
      else {
        answers = [answer.id];
      }
    } else {
      answers = answers.answers.filter(a => a != answer.id);
    }

    this.props.onAnswer({answers, correct: this.checkIfCorrect(answers)});
  }

  updateScore(value) {
    this.setState({
      score: value
    });

    this.props.updateScore(value, this.props.question);
  }

  isAnswerChecked(answer) {
    return !!this.props.answers && this.props.answers.answers && !!this.props.answers.answers.find(a => a === answer.id)
  }

  checkIfCorrect(answers) {
    let correctAnswers = this.props.question.answers
      .filter(a => a.isCorrect)
      .map(a => a.id);

    return correctAnswers.length === answers.length && correctAnswers.every(id => answers.includes(id));
  }

  get answerLines() {
    return Math.max(1, parseInt(this.props.question.answerLines, 10) || 1);
  }

  get subjectiveAnswers() {
    return this.props.answers && this.props.answers.answers ? this.props.answers.answers : [];
  }

  get subjectiveGrades() {
    const grades = this.props.answers && this.props.answers.grades
      ? this.props.answers.grades
      : this.props.answers && (this.props.answers.correct === true || this.props.answers.correct === false)
        ? [this.props.answers.correct]
        : [];

    return Array.from({length: this.answerLines}, (_, index) => {
      if (grades[index] === true || grades[index] === false) {
        return grades[index];
      }

      return this.isBlankSubjectiveAnswer(index) ? false : undefined;
    });
  }

  isBlankSubjectiveAnswer(index) {
    return !this.subjectiveAnswers[index] || !this.subjectiveAnswers[index].trim();
  }

  updateSubjectiveAnswer(answer, index) {
    let answers = [...this.subjectiveAnswers];
    answers[index] = answer;

    this.props.onAnswer({answers});
  }

  gradeSubjectiveAnswer(index, grade) {
    this.props.onGrade({lineIndex: index, grade});
  }

  get canAnswer() {
    return (this.props.answers && this.props.allowTakerViewCorrectAnswer
      && !this.props.allowTakerChangeAnswerIfCorrectDisplayed
      && !this.props.canEdit && !this.props.question.isMultiple) ? false : this.props.canAnswer;
  }

  get showAnswerExplanation() {
    const answers = this.props.answers && this.props.answers.answers;
    return this.props.question.answerExplanation && this.props.showAnswer && (this.props.testEnded || answers && answers.length);
  }

  render() {

    return (
      <div className="question">
        {this.props.canEdit && !this.props.userContext.hasScope(['fto']) && (
          <Fragment>
            <div className="edit-question">
              <button className="button small danger" onClick={() => this.props.onDelete(this.question)}>
                <i className="fa fa-trash"/>
                Delete
              </button>
              <button className="ml-1 button small secondary" onClick={() => this.props.onEdit(this.question)}>
                <i className="fa fa-edit"/>
                Edit
              </button>
            </div>
          </Fragment>
        )}
        <div className="question-title">
          {this.isGraded && this.props.showAnswer && this.props.answers && this.props.answers.answers && this.props.answers.answers.length > 0 && (
            this.props.answers && this.isCorrect ? <i className="fa fa-check correct"/> :
              <i className="fa fa-close incorrect"/>
          )}
          {!this.isGraded && this.props.showAnswer && this.props.answers && this.props.answers.answers && this.props.answers.answers.length > 0 && (
            <i className="fa fa-warning needs-grading"/>
          )}
          {this.props.question.title}
          {this.props.question.isMultiple && (
            <div className="question-instructions">Select all that apply.</div>
          )}
        </div>
        {this.props.question && this.props.question.photo &&
          <DisplayQuestionImage
            questionPhoto={this.props.question.photo}
          />
        }
        <div className="question-answers">
          {!this.props.question.isSubjective && this.props.question.answers.map(answer => (
            <div className={classNames("answer", {
              incorrect: this.isAnswerChecked(answer) && !answer.isCorrect && this.props.showAnswer,
              correct: (this.isAnswerChecked(answer) || this.props.userContext.hasScope(['fto'])) && answer.isCorrect && (this.props.showAnswer || this.props.userContext.hasScope(['fto'])),
              'correct-default': !this.isAnswerChecked(answer) && answer.isCorrect && this.props.testEnded && this.props.showAnswer
            })} key={answer.id}>
              <Checkbox disabled={!this.canAnswer || this.props.userContext.hasScope(['fto'])}
                        onChange={(e) => this.props.question.isMultiple
                          ? this.updateMultipleAnswer(e, answer) : this.updateAnswer(e, answer)}
                        checked={this.isAnswerChecked(answer)}
                        label={answer.title}/>
            </div>
          ))}

          {this.props.question.isSubjective && (
            <Fragment>
              {this.props.testEnded && Array.from({length: this.answerLines}, (_, index) => (
                <div key={index}>
                  <div className={classNames('subjective-answer', {'text-danger': this.isBlankSubjectiveAnswer(index)})}>
                    {this.answerLines === 1 ? 'Answer' : `Answer ${index + 1}`}: {this.subjectiveAnswers[index] || 'No Answer Provided'}
                  </div>
                  {this.props.userContext.hasScope(['fto', 'ftoc']) && (
                    <div className="subjective-grade">
                      <Checkbox
                        label="Correct"
                        checked={this.subjectiveGrades[index] === true}
                        onChange={() => this.gradeSubjectiveAnswer(index, true)}
                        disabled={this.isBlankSubjectiveAnswer(index)}
                      />
                      <Checkbox
                        label="Not correct"
                        checked={this.subjectiveGrades[index] === false}
                        onChange={() => this.gradeSubjectiveAnswer(index, false)}
                        disabled={this.isBlankSubjectiveAnswer(index)}
                      />
                    </div>
                  )}
                </div>
              ))}

              {!this.props.testEnded && Array.from({length: this.answerLines}, (_, index) => (
                <Input
                  key={index}
                  onChange={event => this.updateSubjectiveAnswer(event.target.value, index)}
                  value={this.subjectiveAnswers[index] || ''}
                  type="textarea"
                  placeholder={this.answerLines === 1 ? 'Your Answer' : `Answer ${index + 1}`}
                />
              ))}
            </Fragment>
          )}
          {this.showAnswerExplanation && (
            <div className="answer-explanation">
              {this.props.question.answerExplanation}
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userContext: state.common.userContext,
  };
}

export default connect(mapStateToProps)(Question);
